import { createRouteHelpers } from "../../shared/utils/createRouteHelpers";

export const PATH_API_KEYS = "/member/settings/tokens";

export const routeHelpersApiKeys = createRouteHelpers(PATH_API_KEYS);
